import { button } from '../../../../component/component'

import refreshData from '../../lib/refreshData'

import authRegister from '../../lib/authRegister'
import authReset from '../../lib/authReset'

export default function(o){

  var menu = null

  if (o.store('role') == "admin" || o.store('role') == "author"){
    var right = '102px'
  } else {
    var right = '68px'
  }

  var email = o.store('email').toLowerCase()

  var generateCreateUserButton = function(){
    if (o.store('role') != "admin"){
      return
    }
    var creatUserButton =
      button('create new user','fi-plus')
      .css({
        display: 'block',
      })
      .click(function(){
        authRegister(o,function(error){
          if(error){
            alert('an error occured')
            return
          }
          refreshData(o,function(error){
            o.search.update()
          })  
        })
        menu.remove()
      })
    return creatUserButton
  }

  var generateResetPasswordButton = function(){
    var creatUserButton =
      button('reset password','fi-loop')
      .css({
        display: 'block',
      })
      .click(function(){
        authReset(o, email, false, function(error){
          if(error){
            alert('an error occured')
            return
          }
          location.reload()  
        })
        menu.remove()
      })
    return creatUserButton
  }

  var generateLogoutButton = function(){
    var creatUserButton =
      button('logout user','fi-x')
      .css({
        display: 'block',
      })
      .click(function(e){
        if(confirm('LOGOUT ' + email + '?')){
          o.store.remove('email');
          o.store.remove('token');
          o.store.remove('role');
          location.reload();
        }
        menu.remove()
      })
    return creatUserButton
  }

  var click = function(){

    var overlay =
      $('<div>')
      .css({
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.5)',
      })
      .click(function(){
        menu.remove()
      })

    var buttons =
      $('<div>')
      .css({
        position: 'absolute',
        right: right,
        top: '34px',
      })
      .append([
        generateLogoutButton(),
        generateResetPasswordButton(),
        generateCreateUserButton(),
      ])

    menu =
      $('<div>')
      .css({
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      })
      .append([
        overlay,
        buttons,
      ])

    $('body')
    .append(menu)

  }

  var user =
    button(
      null,
      'fi-torso',
    )
    .css({
      position: 'absolute',
      display: 'inline-block',
      right: right,
      width: '34px',
    })
    .click(click)

  return user

}



// WEBPACK FOOTER //
// ./src/client/view/admin/topbar/user/user.js